// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Insert Wiki Select Dialog*/
.aui-dialog .wiki-parser-selector {
	font-size: 14px;
	margin-right: 5px;
}

.insert-wiki-markup-panel div,
.insert-wiki-markup-panel div form {
	height: 100%;
	text-align: center;
}
.insert-wiki-markup-panel .spinner {
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -73px;
	margin-left: -60px;
}

#insert-wiki-info-title {
	text-align: left;
	margin-left: 10px;
}

#insert-wiki-markup-form {
	height: 95%;
}

#insert-wiki-markup-form .wiki-title span {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	display: -moz-inline-stack;
	display: inline-block;
	margin-bottom: 10px;
	max-width: 48%;
	text-align: left;
	vertical-align: middle;
	width: 48%;
}
#insert-wiki-markup-form .wiki-title span:first-child {
	margin-right: 20px;
}

#insert-wiki-textarea-preview,
#insert-wiki-textarea {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	display: -moz-inline-stack;
	display: inline-block;
	font-size: 14px;
	height: 84%;
	max-width: 48%;
	vertical-align: middle;
	width: 48%;
	resize: none;
}

#insert-wiki-textarea.originalDefault {
	height: 100%;
	min-width: 100%;
	width: 100%;
}

/* Insert Wiki Dialog*/
#insert-wiki-textarea {
	font-family: 'Monaco', 'Consolas', 'Courier New', 'monospace';
	margin-right: 20px;
}
/* Insert Wiki preview*/
#insert-wiki-textarea-preview {
	border: 1px solid var(--ds-border, #ccc);
	border-radius: 3px;
	position: relative;
}
#insert-wiki-textarea-preview iframe {
	border: 0;
	height: 100%;
	left: 0;
	min-height: 100%;
	overflow: hidden;
	position: absolute;
	top: 0;
	width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/editor-plugins/insertwiki/insert-wiki-markup.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;;CAEC,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;CAC3B,sBAAsB;CACtB,0BAA0B;CAC1B,qBAAqB;CACrB,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB,sBAAsB;CACtB,UAAU;AACX;AACA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,8BAA8B;CAC9B,2BAA2B;CAC3B,sBAAsB;CACtB,0BAA0B;CAC1B,qBAAqB;CACrB,eAAe;CACf,WAAW;CACX,cAAc;CACd,sBAAsB;CACtB,UAAU;CACV,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,WAAW;AACZ;;AAEA,sBAAsB;AACtB;CACC,6DAA6D;CAC7D,kBAAkB;AACnB;AACA,uBAAuB;AACvB;CACC,wCAAwC;CACxC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,SAAS;CACT,YAAY;CACZ,OAAO;CACP,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,MAAM;CACN,WAAW;AACZ","sourcesContent":["/* Insert Wiki Select Dialog*/\n.aui-dialog .wiki-parser-selector {\n\tfont-size: 14px;\n\tmargin-right: 5px;\n}\n\n.insert-wiki-markup-panel div,\n.insert-wiki-markup-panel div form {\n\theight: 100%;\n\ttext-align: center;\n}\n.insert-wiki-markup-panel .spinner {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\tmargin-top: -73px;\n\tmargin-left: -60px;\n}\n\n#insert-wiki-info-title {\n\ttext-align: left;\n\tmargin-left: 10px;\n}\n\n#insert-wiki-markup-form {\n\theight: 95%;\n}\n\n#insert-wiki-markup-form .wiki-title span {\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tdisplay: -moz-inline-stack;\n\tdisplay: inline-block;\n\tmargin-bottom: 10px;\n\tmax-width: 48%;\n\ttext-align: left;\n\tvertical-align: middle;\n\twidth: 48%;\n}\n#insert-wiki-markup-form .wiki-title span:first-child {\n\tmargin-right: 20px;\n}\n\n#insert-wiki-textarea-preview,\n#insert-wiki-textarea {\n\t-webkit-box-sizing: border-box;\n\t-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tdisplay: -moz-inline-stack;\n\tdisplay: inline-block;\n\tfont-size: 14px;\n\theight: 84%;\n\tmax-width: 48%;\n\tvertical-align: middle;\n\twidth: 48%;\n\tresize: none;\n}\n\n#insert-wiki-textarea.originalDefault {\n\theight: 100%;\n\tmin-width: 100%;\n\twidth: 100%;\n}\n\n/* Insert Wiki Dialog*/\n#insert-wiki-textarea {\n\tfont-family: 'Monaco', 'Consolas', 'Courier New', 'monospace';\n\tmargin-right: 20px;\n}\n/* Insert Wiki preview*/\n#insert-wiki-textarea-preview {\n\tborder: 1px solid var(--ds-border, #ccc);\n\tborder-radius: 3px;\n\tposition: relative;\n}\n#insert-wiki-textarea-preview iframe {\n\tborder: 0;\n\theight: 100%;\n\tleft: 0;\n\tmin-height: 100%;\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
